// extracted by mini-css-extract-plugin
module.exports = {"whatsapp_wrapper":"WhatsAppButton_whatsapp_wrapper__17QUo","whatsapp_btn":"WhatsAppButton_whatsapp_btn__3RhEi","whatsapp_icon":"WhatsAppButton_whatsapp_icon__3sktb"};